function ArrowLeft({ color }) {
  return (
    <svg width="20" height="20" fill={color} viewBox="0 0 20 20">
      <g fillRule="nonzero">
        <path
          d="M459.249 355.499a1 1 0 00-1.415-1.415l-5.208 5.209a1 1 0 000 1.414l5.208 5.209a1.001 1.001 0 001.416-1.416L454.749 360l4.5-4.501z"
          transform="translate(-446 -350)"
        ></path>
        <path
          d="M466.666 359h-12.812a1 1 0 100 2h12.813a1 1 0 100-2z"
          transform="translate(-446 -350)"
        ></path>
      </g>
    </svg>
  );
}

export default ArrowLeft;
